import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

import {
  Box,
  Grid,
  Typography,
  Card as MuiCard,
  CardContent,
} from "@material-ui/core";

import { spacing } from "@material-ui/system";
import APCategoriasTable from "../../components/APCategoriasTable";

const Card = styled(MuiCard)(spacing);
const HeroCard = styled(Card)`
  overflow: hidden;
  border-radius: 24px;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 52%, #38bdf8 100%);
  color: #fff;
  box-shadow: 0 24px 54px rgba(15, 23, 42, 0.18);
`;

const SurfaceCard = styled(Card)`
  border-radius: 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.18);
`;

const HeroTag = styled(Box)`
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.16);
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 14px;
`;

function ApRestrictionsCategory() {
  return (
    <React.Fragment>
      <Helmet title="Autorizaciones de Categorías" />
      <HeroCard mb={6}>
        <CardContent>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={8}>
              <HeroTag>Access point governance</HeroTag>
              <Typography variant="h2" gutterBottom>
                Autorizaciones de Categorias
              </Typography>
              <Typography variant="body1" style={{ opacity: 0.88 }}>
                Administra de forma visual las categorias publicitarias
                permitidas por access point y mantén una politica de contenido
                mas clara para cada ubicacion.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid container spacing={3} justifyContent="flex-end">
                <Grid item>
                  <Box
                    p={2}
                    borderRadius={18}
                    style={{
                      background: "rgba(255,255,255,0.14)",
                      border: "1px solid rgba(255,255,255,0.16)",
                    }}
                  >
                    <Typography variant="caption">Control</Typography>
                    <Typography variant="h5">Centralizado</Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </HeroCard>

      <SurfaceCard mb={6}>
        <CardContent>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography variant="h4" gutterBottom>
                Reglas por categoria y access point
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Ajusta las restricciones en contexto, con mejor lectura de los
                nodos y una superficie mas ligera para operar dia a dia.
              </Typography>
            </Grid>
          </Grid>

          <Grid justifyContent="center" container spacing={10}>
            <Grid item xs={12}>
              <APCategoriasTable />
            </Grid>
          </Grid>
        </CardContent>
      </SurfaceCard>
    </React.Fragment>
  );
}

export default ApRestrictionsCategory;
